// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__g8lc0","productName":"Table_productName__rUU19"};